import type { FC } from 'react';
import React, { createContext, useContext } from 'react';

const noop = (): void => {
  /* */
};

interface FlightSummaryActionsContextType {
  onContinueWithFlight: () => void;
}

const FlightSummaryActionsContext =
  createContext<FlightSummaryActionsContextType>({
    onContinueWithFlight: noop,
  });

export interface ActionsProviderProps {
  onContinueWithFlight: () => void;
}

const FlightSummaryActionsProvider: FC<ActionsProviderProps> = ({
  onContinueWithFlight = noop,
  children,
}) => {
  return (
    <FlightSummaryActionsContext.Provider
      value={{
        onContinueWithFlight,
      }}
    >
      {children}
    </FlightSummaryActionsContext.Provider>
  );
};

export const useFlightSummaryActions = (): FlightSummaryActionsContextType =>
  useContext(FlightSummaryActionsContext);

export default FlightSummaryActionsProvider;
